import { pipelineNuevos, pipelineExpansion, pipelineTotal, oportunidadesAbiertas, senalesOportunidad } from "./expansionMetrics";
import { ETAPAS_EXPANSION, ETAPAS_EXPANSION_ABIERTAS } from "./expansionConstants";

export function buildPipelineSnapshot(state, fecha, incluirClientes = true) {
  const leads = state.leads || [];
  const opps = state.oportunidadesExpansion || [];
  const ventas = (state.ventas || []).filter((v) => !v.anulada);
  const dias = state.config?.diasEntreSeguimiento || 7;
  const abiertas = oportunidadesAbiertas(opps);
  const sinEstimacion = abiertas.filter((o) => !(Number(o.montoEstimado) > 0)).length;
  const seguimientoVencido = abiertas.filter(
    (o) => senalesOportunidad(o, { diasEstancamiento: dias }).includes("seguimiento_vencido")
  ).length;

  const porEtapa = {};
  ETAPAS_EXPANSION.forEach((etapa) => {
    const enEtapa = opps.filter((o) => o.etapa === etapa);
    porEtapa[etapa] = {
      count: enEtapa.length,
      monto: Math.round(
        enEtapa.reduce((s, o) => {
          const n = Number(o.montoEstimado);
          return s + (Number.isFinite(n) && n > 0 ? n : 0);
        }, 0) * 100
      ) / 100,
    };
  });

  const ts = state._snapshotTs || new Date().toISOString();

  let porCliente;
  if (incluirClientes) {
    const ids = new Set(leads.map(l => l.id));
    const group = rows => {
      const map = new Map();
      for (const row of rows) { const id = ids.has(row.leadId) ? row.leadId : null; if (!map.has(id)) map.set(id, []); map.get(id).push(row); }
      return map;
    };
    const oppsPorLead = group(opps), ventasPorLead = group(ventas);
    const contribution = (lead, leadId) => {
      const snapshot = buildPipelineSnapshot({ ...state, leads: lead ? [lead] : [], oportunidadesExpansion: oppsPorLead.get(leadId) || [], ventas: ventasPorLead.get(leadId) || [] }, fecha, false);
      const { id, fecha: date, actualizadoEn, ...metrics } = snapshot;
      // Zero stage entries are redundant for per-customer contributions.
      metrics.porEtapa = Object.fromEntries(Object.entries(metrics.porEtapa).filter(([, value]) => value.count || value.monto));
      return { leadId, ...metrics };
    };
    porCliente = leads.map(lead => contribution(lead, lead.id));
    if (oppsPorLead.has(null) || ventasPorLead.has(null)) porCliente.push(contribution(null, null));
  }
  return {
    ...(porCliente ? { porCliente } : {}),
    id: fecha,
    fecha,
    actualizadoEn: ts,
    pipelineNuevos: pipelineNuevos(leads, opps),
    pipelineExpansion: pipelineExpansion(opps),
    pipelineTotal: pipelineTotal(leads, opps),
    oportunidadesAbiertas: abiertas.length,
    sinEstimacion,
    seguimientoVencido,
    porEtapa,
    ventasActivasCount: ventas.length,
  };
}

export function upsertSnapshotForToday(prev, fecha, ts) {
  const snap = buildPipelineSnapshot({ ...prev, _snapshotTs: ts }, fecha);
  const existing = (prev.snapshotsPipeline || []).find(s => s.id === fecha);
  if (existing) {
    const { actualizadoEn: oldTime, ...oldValues } = existing;
    const { actualizadoEn: newTime, ...newValues } = snap;
    if (JSON.stringify(oldValues) === JSON.stringify(newValues)) return prev.snapshotsPipeline;
  }
  const list = (prev.snapshotsPipeline || []).filter((s) => s.id !== fecha);
  const merged = [...list, snap].sort((a, b) => a.id.localeCompare(b.id));
  const maxDays = 400;
  if (merged.length <= maxDays) return merged;
  // Retain the last observed snapshot of every older month, preserving its real date.
  const monthly = new Map();
  for (const row of merged.slice(0, -maxDays)) monthly.set(row.fecha.slice(0, 7), row);
  return [...monthly.values(), ...merged.slice(-maxDays)];
}

export function snapshotAtOrBefore(snapshots, dateKey) {
  const list = (snapshots || []).filter((s) => s.id <= dateKey).sort((a, b) => b.id.localeCompare(a.id));
  return list[0] || null;
}

export function isEtapaExpansionAbierta(etapa) {
  return ETAPAS_EXPANSION_ABIERTAS.includes(etapa);
}
